import { render, staticRenderFns } from "./LeaseConfirm.vue?vue&type=template&id=620c1946&scoped=true&"
import script from "./LeaseConfirm.vue?vue&type=script&lang=js&"
export * from "./LeaseConfirm.vue?vue&type=script&lang=js&"
import style0 from "./LeaseConfirm.vue?vue&type=style&index=0&id=620c1946&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c1946",
  null
  
)

export default component.exports